<template>
    <div class="panel-body">
        <HeaderGeneral :vista="'Solicitud de Retiro de Equipos'" :ruta="'- Crear Solicitud de Retiro'" :carpeta="'Clientes'" />
        <hr class="my-4">

        <b-alert v-if="alertA" show variant="danger" dismissible @dismissed="alertA = false">
            {{ alertText }}
        </b-alert>

        <!-- Sección Paciente (misma que CrearSolicitudes) -->
        <b-card class="butonopcionesMS" v-b-toggle="['collapse-paciente']">
            Paciente <b-icon icon="chevron-down" class="felchasicono" />
        </b-card>
        <b-collapse visible id="collapse-paciente" class="mt-2">
            <b-card>
                <b-overlay :show="buscandoPaciente" rounded="sm" opacity="0.6">
                    <template #overlay>
                        <div class="text-center">
                            <b-spinner variant="primary" style="width: 2rem; height: 2rem;"></b-spinner>
                            <p class="mt-2 mb-0" style="color: #007bff; font-weight: 600;">Buscando paciente...</p>
                        </div>
                    </template>
                    <datalist id="busqueda-paciente-list">
                        <option v-for="size in sizes" :value="size.identificacion" :key="size.id">
                            {{ size.nombre }}
                        </option>
                    </datalist>
                    <vue-form-generator :schema="schema" :model="model" :options="formOptions" ref="formPaciente" />
                </b-overlay>
            </b-card>
        </b-collapse>

        <!-- Sección Equipos a Retirar (mismo checklist que CrearSolicitudes) -->
        <b-card class="butonopcionesMS" v-b-toggle="['collapse-equipos']">
            Equipos a Retirar <b-icon icon="chevron-down" class="felchasicono" />
        </b-card>
        <b-collapse visible id="collapse-equipos" class="mt-2">
            <b-card>
                <vue-form-generator :schema="schema1" :model="model" :options="formOptions" ref="formEquipos" />
            </b-card>
        </b-collapse>

        <!-- Sección Observaciones -->
        <b-card class="butonopcionesMS" v-b-toggle="['collapse-obs']">
            Observaciones <b-icon icon="chevron-down" class="felchasicono" />
        </b-card>
        <b-collapse visible id="collapse-obs" class="mt-2 mb-4">
            <b-card>
                <vue-form-generator :schema="schema2" :model="model" :options="formOptions" ref="formObs" />
            </b-card>
        </b-collapse>

        <!-- Sección Adjuntos -->
        <b-card class="butonopcionesMS mb-0" v-b-toggle="['collapse-adjuntos']">
            Documentos adjuntos * <b-icon icon="chevron-down" class="felchasicono" />
            <small class="text-muted font-weight-normal ml-2">(obligatorio — ej: orden médica, prescripción)</small>
        </b-card>
        <b-collapse visible id="collapse-adjuntos" class="mt-2 mb-4">
            <b-card>
                <AdjuntosRetiro ref="adjuntos" :id-retiro="null" />
            </b-card>
        </b-collapse>

        <div class="centro">
            <b-button @click="enviar" class="botonregidtro" :disabled="load">
                <span v-if="!load" class="ingresar poppins-semi-bold-white-14px">Enviar solicitud de retiro</span>
                <div v-else>
                    <b-spinner small></b-spinner>
                    <span class="sr-only ingresar poppins-semi-bold-white-14px">Cargando...</span>
                </div>
            </b-button>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import Vue from 'vue';
import VueFormGenerator from 'vue-form-generator';
import HeaderGeneral from "../../components/HeaderGeneral.vue";
import AdjuntosRetiro from "../../components/AdjuntosRetiro.vue";
import 'vue-form-generator/dist/vfg.css';
import 'vue-form-generator/dist/vfg-core.css';
import Swal from 'sweetalert2';

Vue.use(VueFormGenerator);

const clientes = RepositoryFactory.get("clientes");
const config   = RepositoryFactory.get("config");
const retiro   = RepositoryFactory.get("retiro");

export default {
    components: {
        "vue-form-generator": VueFormGenerator.component,
        HeaderGeneral,
        AdjuntosRetiro,
    },

    watch: {
        "model.edad"(newValue) {
            if (newValue) {
                this.calcularEdad(newValue);
                if (newValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
                    const [year, month, day] = newValue.split('-');
                    this.model.fechaConvertida = `${day}/${month}/${year}`;
                } else {
                    const fecha = new Date(newValue);
                    if (!isNaN(fecha.getTime())) {
                        const d = fecha.getDate().toString().padStart(2,'0');
                        const m = (fecha.getMonth()+1).toString().padStart(2,'0');
                        this.model.fechaConvertida = `${d}/${m}/${fecha.getFullYear()}`;
                    } else {
                        this.model.fechaConvertida = '';
                    }
                }
            } else {
                this.model.fechaConvertida = '';
                this.model.edad_calculada  = null;
            }
        },
    },

    data() {
        return {
            load: false,
            alertA: false,
            alertText: '',
            idpaciente: null,
            buscandoPaciente: false,
            sizes: [],
            municipios: [],

            // ── model idéntico al de CrearSolicitudes (campos relevantes para retiro) ──
            model: {
                tipo_identificacion: null,
                identificacion: '',
                nombre: '',
                edad: null,
                edad_calculada: null,
                fechaConvertida: '',
                genero: '',
                nacionalidad: 'Colombiana',
                departamento: null,
                municipio: null,
                barrio: '',
                typevia: '',
                number: null,
                number1: null,
                number2: null,
                typeinmueble: '',
                number3: '',
                bloque: 0,
                number4: '',
                telefono1: null,
                telefono2: 0,
                telefono3: 0,
                namecontacto: '',
                email: '',
                obsevacionContact: '',
                // equipos
                elementos_retiro: null,
                // observaciones retiro
                observaciones_retiro: '',
            },

            // ── Schema Paciente: mismo que CrearSolicitudes ──
            schema: {
                fields: [
                    {
                        type: 'select',
                        label: 'Tipo de Identificación *',
                        model: 'tipo_identificacion',
                        values: [],
                        required: true,
                        styleClasses: 'col-md-5 arrow',
                        validator: ['required'],
                        selectOptions: { noneSelectedText: 'Seleccione una opción' },
                    },
                    {
                        type: 'input',
                        inputType: 'number',
                        inputName: 'identificacion',
                        label: 'Número de Identificación *',
                        list: 'busqueda-paciente-list',
                        model: 'identificacion',
                        required: true,
                        styleClasses: 'offset-md-2 col-md-5',
                        max: 999999999999999,
                        min: 0,
                        validator: ['required', 'number'],
                        onChanged: (model, newVal) => { this.handleInputChange(newVal); },
                    },
                    {
                        type: 'input',
                        inputType: 'text',
                        inputName: 'nombre',
                        label: 'Nombre completo *',
                        model: 'nombre',
                        required: true,
                        styleClasses: 'col-md-5',
                        max: 70,
                        validator: ['required', 'string'],
                    },
                    {
                        type: 'input',
                        inputName: 'edad',
                        inputType: 'date',
                        label: 'Fecha de nacimiento *',
                        model: 'edad',
                        required: true,
                        styleClasses: 'offset-md-2 col-md-5',
                        onChanged: (model, newVal) => { this.calcularEdad(newVal); },
                    },
                    {
                        type: 'input',
                        inputType: 'number',
                        inputName: 'edad_calculada',
                        label: 'Edad (años)',
                        model: 'edad_calculada',
                        readonly: true,
                        styleClasses: 'col-md-2',
                        disabled: true,
                        placeholder: 'Se calcula automáticamente',
                    },
                    {
                        type: 'select',
                        label: 'Género *',
                        model: 'genero',
                        values: [],
                        required: true,
                        styleClasses: 'offset-md-2 col-md-3',
                        validator: ['required'],
                        selectOptions: { noneSelectedText: 'Seleccione una opción' },
                    },
                    {
                        type: 'input',
                        inputType: 'text',
                        inputName: 'nacionalidad',
                        label: 'Nacionalidad',
                        model: 'nacionalidad',
                        styleClasses: 'offset-md-2 col-md-2',
                        max: 70,
                    },
                    {
                        type: 'select',
                        label: 'Departamento *',
                        model: 'departamento',
                        values: [],
                        required: true,
                        styleClasses: 'col-md-5 arrow',
                        validator: ['required'],
                        onChanged: (model, newVal) => { this.municipioXDepartamento(newVal); },
                        selectOptions: { noneSelectedText: 'Seleccione una opción' },
                    },
                    {
                        type: 'select',
                        label: 'Municipio *',
                        model: 'municipio',
                        values: [],
                        dependencies: ['departamento'],
                        required: true,
                        styleClasses: 'offset-md-2 col-md-5 arrow',
                        validator: ['required'],
                        disabled: (model) => !model.departamento,
                        selectOptions: { noneSelectedText: 'Seleccione una opción' },
                    },
                    {
                        type: 'select',
                        label: 'Tipo de vía',
                        model: 'typevia',
                        values: [],
                        required: false,
                        styleClasses: 'col-md-3 arrow',
                        selectOptions: { noneSelectedText: 'Seleccione una opción' },
                    },
                    {
                        type: 'input',
                        inputType: 'text',
                        label: 'Número',
                        inputName: 'number',
                        model: 'number',
                        required: false,
                        styleClasses: 'offset-md-1 col-md-2',
                        max: 70,
                    },
                    {
                        type: 'input',
                        inputType: 'text',
                        label: 'Número',
                        inputName: 'number1',
                        model: 'number1',
                        required: false,
                        styleClasses: 'offset-md-1 col-md-2',
                        max: 70,
                    },
                    {
                        type: 'input',
                        inputType: 'text',
                        label: 'Número',
                        inputName: 'number2',
                        model: 'number2',
                        required: false,
                        styleClasses: 'offset-md-1 col-md-2',
                        max: 70,
                    },
                    {
                        type: 'select',
                        label: 'Tipo de inmueble',
                        model: 'typeinmueble',
                        values: [],
                        required: false,
                        styleClasses: 'col-md-3 arrow',
                        selectOptions: { noneSelectedText: 'Seleccione una opción' },
                    },
                    {
                        type: 'input',
                        inputType: 'text',
                        label: 'Número/Nombre',
                        inputName: 'number3',
                        model: 'number3',
                        styleClasses: 'offset-md-1 col-md-2',
                        max: 70,
                    },
                    {
                        type: 'select',
                        label: 'Bloque o interior',
                        model: 'bloque',
                        values: [],
                        styleClasses: 'offset-md-1 col-md-2 arrow',
                        selectOptions: { noneSelectedText: 'Seleccione una opción' },
                    },
                    {
                        type: 'input',
                        inputType: 'text',
                        label: 'Número/Nombre',
                        inputName: 'number4',
                        model: 'number4',
                        styleClasses: 'offset-md-1 col-md-2',
                        max: 70,
                    },
                    {
                        type: 'input',
                        inputType: 'text',
                        inputName: 'barrio',
                        label: 'Barrio, Localidad o Sector *',
                        model: 'barrio',
                        required: true,
                        styleClasses: '',
                        max: 70,
                    },
                    {
                        type: 'input',
                        inputType: 'number',
                        inputName: 'telefono1',
                        label: 'Teléfono 1 *',
                        model: 'telefono1',
                        required: true,
                        styleClasses: 'col-md-4',
                        max: 70,
                        min: 0,
                        validator: ['required'],
                    },
                    {
                        type: 'input',
                        inputType: 'number',
                        label: 'Teléfono 2',
                        inputName: 'telefono2',
                        model: 'telefono2',
                        required: false,
                        styleClasses: 'offset-md-1 col-md-3',
                        max: 70,
                        min: 0,
                    },
                    {
                        type: 'input',
                        inputType: 'text',
                        inputName: 'namecontacto',
                        label: 'Nombre del contacto',
                        model: 'namecontacto',
                        styleClasses: 'col-md-5',
                        max: 70,
                    },
                    {
                        type: 'input',
                        inputType: 'text',
                        inputName: 'email',
                        label: 'Correo',
                        model: 'email',
                        styleClasses: 'offset-md-2 col-md-5',
                        max: 70,
                    },
                    {
                        type: 'textArea',
                        label: 'Observaciones del paciente',
                        model: 'obsevacionContact',
                        required: false,
                        styleClasses: '',
                        max: 500,
                        rows: 4,
                        cols: 30,
                    },
                ],
            },

            // ── Schema Equipos a Retirar: mismo checklist que CrearSolicitudes ──
            schema1: {
                fields: [
                    {
                        type: 'checklist',
                        label: 'Seleccione los equipos a retirar *',
                        model: 'elementos_retiro',
                        multi: true,
                        styleClasses: 'col-md-8',
                        required: true,
                        validator: ['required'],
                        values: [],
                        checklistOptions: { value: 'id' },
                    },
                ],
            },

            // ── Schema Observaciones ──
            schema2: {
                fields: [
                    {
                        type: 'textArea',
                        label: 'Observaciones del retiro',
                        model: 'observaciones_retiro',
                        required: false,
                        styleClasses: '',
                        max: 500,
                        rows: 4,
                        cols: 30,
                        placeholder: 'Información adicional sobre el retiro, estado de los equipos, etc.',
                    },
                ],
            },

            formOptions: {
                validateAfterLoad: false,
                validateAfterChanged: true,
                validateAsync: false,
                validationErrorClass: 'has-error',
                validationSuccessClass: 'has-success',
                i18n: { selected: 'seleccionado' },
            },

            // Data auxiliar para municipios y departamentos
            valoresdepartamentos: [],
        };
    },

    async created() {
        try {
            const response = await config.listasDesplegables({ "nombre_entidad": "listados" });

            // Tipos de documento
            const listaTiposDocumento = response.find(i => i.data.nombre_lista === 'Tipos_documento');
            this.schema.fields[0]['values'] = listaTiposDocumento.data.rows;

            // Género
            const listaTiposGenero = response.find(i => i.data.nombre_lista === 'genero');
            this.schema.fields[5]['values'] = listaTiposGenero.data.rows;

            // Departamentos
            const listaDepartamentos = response.find(i => i.data.nombre_lista === 'divipola_colombia');
            this.valoresdepartamentos = listaDepartamentos.data.rows;
            const departamentos = this.valoresdepartamentos
                .map(x => ({ id: x.codigo_departamento, name: x.nombre_departamento }))
                .filter((obj, idx, self) => idx === self.findIndex(o => o.id === obj.id));
            this.schema.fields[7]['values'] = departamentos;

            // Tipo de vía
            const listaTiposVia = response.find(i => i.data.nombre_lista === 'tipos_via');
            this.schema.fields[9]['values'] = listaTiposVia.data.rows;

            // Tipo inmueble
            const listaTiposInmueble = response.find(i => i.data.nombre_lista === 'tipos_edificacion');
            this.schema.fields[13]['values'] = listaTiposInmueble.data.rows;

            // Bloque/interior
            const listaTiposBloque = response.find(i => i.data.nombre_lista === 'tipos_unidad');
            this.schema.fields[15]['values'] = listaTiposBloque.data.rows;

            // Equipos: mismo listado "elementos" que CrearSolicitudes
            const listaTiposElementos = response.find(i => i.data.nombre_lista === 'elementos');
            this.schema1.fields[0]['values'] = listaTiposElementos.data.rows;

        } catch (e) {
            console.error('[CrearSolicitudRetiro] Error cargando listados:', e);
        }
    },

    methods: {
        calcularEdad(fechaNacimiento) {
            if (!fechaNacimiento) return;
            const hoy   = new Date();
            const nac   = new Date(fechaNacimiento);
            let edad    = hoy.getFullYear() - nac.getFullYear();
            const m     = hoy.getMonth() - nac.getMonth();
            if (m < 0 || (m === 0 && hoy.getDate() < nac.getDate())) edad--;
            this.model.edad_calculada = edad;
        },

        async municipioXDepartamento(codigoDepartamento) {
            if (!codigoDepartamento) return;
            const municipiosFiltrados = this.valoresdepartamentos
                .filter(x => x.codigo_departamento === codigoDepartamento)
                .map(x => ({ id: x.codigo_municipio, name: x.nombre_municipio }));
            this.schema.fields[8]['values'] = municipiosFiltrados;
            this.model.municipio = null;
        },

        async handleInputChange(event) {
            this.buscandoPaciente = true;
            const where = [{
                "AND": [
                    { "id": { "notEquals": "" } },
                    { "numero_de_identificacion": { "equals": event } },
                ],
            }];
            const params = {
                "nombreEntidad": "entidad_paciente",
                "idVersion": 5,
                "column": "id",
                "type": "desc",
                "size": 100000,
                "page": 1,
            };
            let responsep;
            try {
                responsep = await config.getMetaData(params, where, []);
            } catch (e) {
                this.buscandoPaciente = false;
                return;
            }
            if (!responsep || responsep.status !== 200 || !responsep.message || !responsep.message.rows) {
                this.buscandoPaciente = false;
                return;
            }
            const selectedValue = event;
            const empty = responsep.message.rows.find(
                size => size.data.numero_de_identificacion == selectedValue
            );

            this.sizes = responsep.message.rows.map((x) => ({
                'idpaciente':         parseInt(x.data.id) ?? '',
                'afiliacion':         parseInt(x.data.afiliacion) ?? '',
                'barrio':             x.data.barrio ?? '',
                'cobertura':          parseInt(x.data.cobertura) ?? '',
                'departamento':       x.data.departamento ?? '',
                'municipio':          x.data.municipio ?? '',
                'nombre':             x.data.nombre_completo ?? '',
                'identificacion':     x.data.numero_de_identificacion ?? '',
                'telefono1':          x.data.telefono_1 ?? '',
                'telefono2':          x.data.telefono_2 ?? '',
                'telefono3':          x.data.telefono_3 ?? '',
                'tipo_identificacion':parseInt(x.data.tipo_de_identificacion) ?? '',
                'edad': x.data.nacimiento
                    ? (() => {
                        const [day, month, year] = x.data.nacimiento.split('/');
                        const date = new Date(`${day}-${month}-${year}`);
                        return isNaN(date.getTime()) ? '' : date.toISOString().split('T')[0];
                    })()
                    : '',
                'genero':       x.data.genero ?? '',
                'nacionalidad': x.data.nacionalidad ?? '',
                'typevia':      x.data.tipo_via ?? '',
                'number':       x.data.number ?? '',
                'number1':      x.data.number1 ?? '',
                'number2':      x.data.number2 ?? '',
                'typeinmueble': x.data.tipo_inmueble ?? '',
                'number3':      x.data.number3 ?? 0,
                'bloque':       x.data.bloque ?? 0,
                'number4':      x.data.number4 ?? 0,
                'namecontacto': x.data.nombre_contacto ?? '',
                'email':        x.data.email ?? '',
                'obsevacionContact': x.data.observacion_contacto ?? '',
            }));

            if (!empty) {
                this.buscandoPaciente = false;
                return;
            }

            // Conservar los campos de equipos y observaciones del retiro antes de pisar el model
            const elementosRetiro    = this.model.elementos_retiro;
            const observacionesRetiro = this.model.observaciones_retiro;

            const paciente = this.sizes.find(s => s.identificacion === selectedValue);
            this.model = {
                ...paciente,
                elementos_retiro:     elementosRetiro,
                observaciones_retiro: observacionesRetiro,
            };

            this.idpaciente = paciente.idpaciente;
            await this.municipioXDepartamento(this.model.departamento);
            // Restaurar municipio después de cargar el listado
            this.$nextTick(() => {
                this.model.municipio = paciente.municipio;
            });

            this.buscandoPaciente = false;
        },

        async enviar() {
            // Validar formulario con vue-form-generator
            const validPaciente = this.$refs.formPaciente ? this.$refs.formPaciente.validate() : true;
            const validEquipos  = this.$refs.formEquipos  ? this.$refs.formEquipos.validate()  : true;

            const errores = [
                ...(validPaciente === true ? [] : (Array.isArray(validPaciente) ? validPaciente : [validPaciente])),
                ...(validEquipos  === true ? [] : (Array.isArray(validEquipos)  ? validEquipos  : [validEquipos])),
            ];

            if (!this.model.elementos_retiro || !this.model.elementos_retiro.length) {
                errores.push('Debe seleccionar al menos un equipo a retirar.');
            }

            if (!this.$refs.adjuntos || !this.$refs.adjuntos.hayArchivos()) {
                errores.push('Debe adjuntar al menos un documento (ej: orden médica, prescripción).');
            }

            if (errores.length) {
                this.alertText = typeof errores[0] === 'string' ? errores[0] : 'Complete los campos requeridos.';
                this.alertA   = true;
                window.scrollTo(0, 0);
                return;
            }

            this.load  = true;
            this.alertA = false;
            this.exito  = false;

            try {
                const payload = {
                    // ── Campos compatibles con TableGeneral (mismos nombres que entidad_solicitud) ──
                    id_paciente:    this.idpaciente,
                    tipo_documento: this.model.tipo_identificacion,
                    documento:      this.model.identificacion,
                    nombre_completo: this.model.nombre,
                    nacimiento:     this.model.fechaConvertida,
                    edad_calculada: this.model.edad_calculada,
                    genero:         this.model.genero,
                    nacionalidad:   this.model.nacionalidad,
                    departamento:   this.model.departamento,
                    municipio:      this.model.municipio,
                    barrio:         this.model.barrio,
                    tipo_via:       this.model.typevia,
                    number:         this.model.number,
                    number1:        this.model.number1,
                    number2:        this.model.number2,
                    tipo_inmueble:  this.model.typeinmueble,
                    number3:        this.model.number3,
                    bloque:         this.model.bloque,
                    number4:        this.model.number4,
                    telefono_1:     this.model.telefono1,
                    telefono_2:     this.model.telefono2,
                    nombre_contacto: this.model.namecontacto,
                    email:           this.model.email,
                    observacion_contacto: this.model.obsevacionContact,
                    // ── Campos específicos del retiro independiente ──
                    elementos_retiro:    this.model.elementos_retiro,
                    observaciones_retiro: this.model.observaciones_retiro,
                };

                const resp = await retiro.crearRetiroIndependiente(payload);

                if (resp && resp[0] && resp[0].id) {
                    const idNuevo = resp[0].id;
                    // Subir adjuntos si los hay (después de tener el ID)
                    if (this.$refs.adjuntos && this.$refs.adjuntos.hayArchivos()) {
                        await this.$refs.adjuntos.subirArchivos(idNuevo);
                    }
                    this.resetForm();
                    await Swal.fire({
                        icon: 'success',
                        title: '¡Solicitud registrada!',
                        html: `La solicitud de retiro N° <strong>${idNuevo}</strong> fue creada exitosamente.<br>Será redirigido a sus solicitudes de retiro.`,
                        confirmButtonText: 'Ver mis retiros',
                        confirmButtonColor: '#198754',
                        allowOutsideClick: false,
                    });
                    this.$router.push({ name: 'cliente-mis-retiros-independientes' });
                } else {
                    throw new Error('Respuesta inesperada');
                }
            } catch (e) {
                this.alertText = 'Error al registrar la solicitud. Intente nuevamente.';
                this.alertA   = true;
            } finally {
                this.load = false;
            }
        },

        resetForm() {
            this.idpaciente = null;
            this.sizes = [];
            this.model = {
                tipo_identificacion: null,
                identificacion: '',
                nombre: '',
                edad: null,
                edad_calculada: null,
                fechaConvertida: '',
                genero: '',
                nacionalidad: 'Colombiana',
                departamento: null,
                municipio: null,
                barrio: '',
                typevia: '',
                number: null,
                number1: null,
                number2: null,
                typeinmueble: '',
                number3: '',
                bloque: 0,
                number4: '',
                telefono1: null,
                telefono2: 0,
                telefono3: 0,
                namecontacto: '',
                email: '',
                obsevacionContact: '',
                elementos_retiro: null,
                observaciones_retiro: '',
            };
            // Limpiar municipios
            this.schema.fields[8]['values'] = [];
        },
    },
};
</script>
